"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchPositionCashflowSummary = void 0;
const common_business_1 = require("@pionex-web-kit/common-business");
const rxjs_1 = require("rxjs");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const react_1 = require("react");
function useFetchPositionCashflowSummary({ position_id, isHistory, isActive, }) {
    const [{ loading, value = new Map() }, fetch] = (0, common_business_1.useAsyncFn)((params) => (0, rxjs_1.firstValueFrom)((0, FutureAPI_1.queryPositionsCashflowSummary)(params).pipe((0, rxjs_1.map)((data) => {
        var _a, _b;
        return ((_b = (_a = data === null || data === void 0 ? void 0 : data.cashflows) === null || _a === void 0 ? void 0 : _a[position_id].items.reduce((map, item) => {
            var _a;
            map.set(item.type, (_a = item.coins[0]) === null || _a === void 0 ? void 0 : _a.amount);
            return map;
        }, new Map())) !== null && _b !== void 0 ? _b : new Map());
    }))));
    (0, react_1.useEffect)(() => {
        if (isActive) {
            fetch({
                position_ids: [position_id],
                is_active: !isHistory,
            });
        }
    }, [position_id, isHistory, fetch, isActive]);
    const fetchFn = (0, common_business_1.usePersistFn)(() => {
        return fetch({
            position_ids: [position_id],
            is_active: !isHistory,
        });
    });
    return {
        feeMap: value,
        loading,
        fetch: fetchFn,
    };
}
exports.useFetchPositionCashflowSummary = useFetchPositionCashflowSummary;
